import script from "./ReportingEntityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingEntityModal.vue?vue&type=script&setup=true&lang=js"

import "./ReportingEntityModal.vue?vue&type=style&index=0&id=06b2a67e&lang=scss"

const __exports__ = script;

export default __exports__